import { categoryComboApi } from '../../../api/category/categoryComboApi';
import { ICategoryCombo } from '../../../model/respone/category/ICategoryCombo';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { rootActions } from '../../actions/rootActions';
import { eCategoryComboActionTypeIds, ICategoryComboActions } from './../../action-types/category/ICategoryComboActionType';
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
const mainAction = rootActions.category.categoryCombo;
export function* categoryComboSaga(): any {
    yield takeLatest(eCategoryComboActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eCategoryComboActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eCategoryComboActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ICategoryComboActions): any {
    const res: IBaseRespone = yield call(categoryComboApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ICategoryComboActions): any {
    let res: IBaseRespone;
    const categoryCombo = action.payload as ICategoryCombo;
    if (categoryCombo.id > 0) {
        res = yield call(categoryComboApi.Update, categoryCombo)
    } else {
        res = yield call(categoryComboApi.Insert, categoryCombo)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ICategoryComboActions): any {
    const res: IBaseRespone = yield call(categoryComboApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}

